import { gql } from '@apollo/client';

export const DELETE_INVENTORY = gql`
  mutation deleteInventory($id: ID!) {
    deleteInventory(id: $id)
  }
`;
